<fieldset class="question-group">
  <legend class="question-group__legend" [attr.id]="legendId" [ngClass]="legendClass" [innerHTML]="legend"></legend>
  <ng-content></ng-content>
</fieldset>
